module.exports = __webpack_public_path__ + "static/media/main-background.9d5b9df7.jpg";